export enum CheckoutUpsellImageAspectRatio {
  Square = "SQUARE",
  Portrait45 = "PORTRAIT_4_5",
  Portrait34 = "PORTRAIT_3_4",
  Portrait23 = "PORTRAIT_2_3",
}
